<template>
  <div>
    <a-spin :spinning="loading">
      <el-table
        :header-cell-style="{background:'#f5f5f5','color':'#424242'}"
        :data="tableData.aaData"
        :fit="true"
        ref="multipleTable"
        :height="height"
        :border="true"
        :highlight-current-row="highlight"
        :row-style="tableRowStyle"
        :row-key="rowKey"
        @row-click="$emit('table-row-click', $event)"
        @current-change="$emit('table-current-change', $event)"
        @selection-change="$emit('table-selection-change', $event)">
        <slot>
        </slot>
        <div slot="empty">
          <div style="margin: 140px">
            <img src="./notdata.png" width="100"/>
            <p style="margin-top: 20px">~ 暂无数据 ~</p>
          </div>
        </div>
      </el-table>
      <div :style="{'height': '20px'}"></div>
      <el-pagination v-show="isPager" v-if="tableData.aaData && tableData.aaData.length>0"
                     :page-size="tableQuery.size"
                     :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
                     :layout="layout"
                     :background="true"
                     :currentPage="currentPage"
                     :total="tableData.iTotalRecords"
                     @current-change="$emit('current-change', $event)"
                     @size-change="$emit('size-change', $event)"></el-pagination>
    </a-spin>
  </div>
</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: false,
      default: 1
    },
    isPager: {
      type: Boolean,
      required: false,
      default: true
    },
    tableQuery: {
      type: Object,
      required: true
    },
    tableData: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: '->, total, sizes, prev, pager, next, jumper'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false,
      required: false
    },
    height: {
      type: Number,
      required: false
    },
    myRowStyle: ''
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
    tableRowStyle ({ row, rowIndex }) {
      if (this.myRowStyle !== '') {
        return this.myRowStyle
      } else {
        return 'background-color: #ffffff;'
      }
    },
    rowKey (row) {
      return row.id
    }
  },
  computed: {
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/datatable/index.vue